export default __webpack_public_path__ + "static/media/Mechelen_logo.ee38a060.svg";